const IMG_BASE = `${process.env.REACT_APP_IMAGE_BASE_URL || "/images"}/membership`;

export const DEFAULT_HERO_SUBHEAD =
  "매물 노출부터 고객 상담, 계약까지\n1등 중개사들이 선택한 영업 플랫폼, 디스코";
export const DEFAULT_PRIMARY_CTA = "상담 예약하기";

export const FEATURE_GROUPS = [
  {
    num: "01",
    title: "매달 지급되는 3가지 이용권",
    features: [
      {
        tag: "등기 열람권",
        title: "무료 등기 열람",
        desc: "원하는 지번의 등기부를 열람 및 보관 가능\n멤버십 회원은 매달 등기 열람권 자동 지급!",
        img: `${IMG_BASE}/feature-free-registry-v2.png`,
      },
      {
        tag: "광고 포인트",
        title: "디스코 추천 광고",
        desc: "홈 화면 우측 하단 추천 광고 영역에 노출. 매달 광고 포인트를 지급받아 즉시 활용.",
        img: `${IMG_BASE}/feature-recommend-ad.png`,
      },
      {
        tag: "매입 열람권",
        title: "매입 요청 확인",
        desc: "고객이 등록한 매입 요청을 열람. 비즈니스·프로 등급에 매달 자동 지급.",
        img: `${IMG_BASE}/feature-buy-request-v3.png`,
        imgPosition: "center top",
        note: "베이직 회원은 기본 지급되지 않습니다",
      },
    ],
  },
  {
    num: "02",
    title: "지도와 명함으로 먼저 발견되는 중개사",
    features: [
      {
        tag: "지도 프로필 마커",
        title: "중개사무소 위치 노출",
        desc: "활동 지역 지도에서 사무소 위치가 마커로 표시. 베이직·비즈니스·프로 등급별 마커 디자인이 달라집니다.",
        img: `${IMG_BASE}/feature-office-marker.png`,
      },
      {
        tag: "명함 노출",
        title: "활동 지역 내 명함 노출",
        desc: "홈·실거래가·지도 우측 상단 '디스코 추천 공인중개사' 영역 노출. 프로·비즈니스 등급별 디자인 차등.",
        img: `${IMG_BASE}/feature-business-card-v3.png`,
        note: "베이직 회원은 지원되지 않습니다",
      },
    ],
  },
  {
    num: "03",
    title: "지도 · 리스트 · 실거래가",
    layout: "text",
    features: [
      { tag: "지도 매물 마커", title: "지도 기반 매물 광고", desc: "디스코 지도에 등록한 매물이 마커로 노출. 활동 지역과 등급에 따라 노출 우선순위가 달라집니다." },
      { tag: "매물 리스트", title: "지역 기반 매물 광고", desc: "등록한 매물이 해당 지역 매물 리스트에 노출. 활동 지역과 등급별 우선순위 차등 적용." },
      { tag: "실거래가 페이지", title: "매물 상세 정보 노출", desc: "해당 지번 클릭 시 등록 매물의 상세 정보가 실거래가 페이지에 노출. 등급별 우선순위 차등." },
    ],
  },
  {
    num: "04",
    title: "계약을 더 빠르게 만드는 전용 도구",
    features: [
      { tag: "POP · 매물보고서", title: "보고서 자동 생성", desc: "멤버십 회원은 번거로운 문서 작업 없이 편하게 보고서 생성! 필요한 내용만 골라 자유롭게 구성 가능.", img: `${IMG_BASE}/property-report.png` },
      { tag: "채팅 상담", title: "고객과 1:1 채팅", desc: "매물 문의 고객과 디스코 안에서 바로 채팅으로 상담. 전화 없이도 빠르게 소통하세요.", img: `${IMG_BASE}/feature-chat.png` },
      { tag: "AI 매물설명", title: "매물 설명 자동 작성", desc: "매물 정보만 입력하면 AI가 매력적인 매물 설명문을 자동으로 생성해드립니다.", img: `${IMG_BASE}/feature-ai-description-v2.png` },
      { tag: "AI 포스트", title: "홍보 포스트 자동 생성", desc: "매물 기반의 홍보 포스트를 AI가 자동 제작. 이미지·문구를 다듬어 바로 활용하세요.", img: `${IMG_BASE}/feature-ai-post.png` },
      { tag: "디스코 프차", title: "점포 매물 · 점주 추천", desc: "프랜차이즈 점포개발 담당자에게 매물 제안. 일부 브랜드는 출점 시 인센티브 제공.", img: `${IMG_BASE}/store-recommend.png` },
      { tag: "유튜브 영상", title: "매물 영상 재생", desc: "매물 등록 시 유튜브(쇼츠) 링크 첨부. 디스코 매물 상세에서 바로 재생.", img: `${IMG_BASE}/video-player.png` },
    ],
  },
];

export const PLANS = [
  { name: "무료", desc: "매물을 등록해보고 싶은 중개사", priceLabel: "0원", priceSub: "평생 무료", featured: false },
  { name: "베이직", desc: "전속매물, 소량의 매물을 광고하고 싶은 중개사", priceLabel: "3 / 6 / 9만원", priceSub: "월 구독 · 지역별 상이", featured: false },
  { name: "비즈니스", desc: "꾸준히 계약을 만드는 중개사", priceLabel: "10 / 20 / 30만원", priceSub: "월 구독 · 지역별 상이", limited: true, featured: true },
  { name: "프로", desc: "지역 1위를 노리는 중개사", priceLabel: "20 / 45 / 70만원", priceSub: "월 구독 · 지역별 상이", limited: true, featured: false },
];

export const PLAN_HIGHLIGHTS = {
  무료: ["매물 등록 무제한", "기능 체험 용도"],
  베이직: ["매물 노출 30개", "무료 등기권 · 광고 포인트", "지도 매물 마커 2순위", "지역별 가입자 수 제한 없음"],
  비즈니스: ["매물 노출 500개", "매입 열람권 포함", "명함 노출", "지도 매물 마커 1순위", "지역별 정원제"],
  프로: ["매물 노출 무제한", "실거래가 페이지 1순위", "모든 혜택 최대 적용", "지역별 정원제"],
};

export const PLAN_ROWS = [
  { section: "매물 운영" },
  { label: "매물 등록수", vals: ["무제한", "무제한", "무제한", "무제한"] },
  { label: "매물 광고수", vals: ["0개", "30개", "500개", "무제한"] },
  { section: "부가 혜택" },
  { label: "무료 등기권", vals: [false, true, true, true] },
  { label: "광고 포인트", vals: [false, true, true, true] },
  { label: "매입 열람권", vals: [false, false, true, true] },
  { section: "노출 · 마커" },
  { label: "지도 프로필 마커", vals: [false, true, true, true] },
  { label: "명함 노출", vals: [false, false, true, true] },
  { label: "실거래가 페이지 노출", vals: [false, 3, 2, 1] },
];

export const REGION_GRADES = [
  { code: "A", title: "핵심지역", desc: "강남·서초 등" },
  { code: "B", title: "시 지역", desc: "핵심지역 외 시 지역" },
  { code: "C", title: "군 지역", desc: "광역시 제외 군 지역" },
];

export const PRICE_MATRIX = [
  { plan: "베이직", a: "9만원", b: "6만원", c: "3만원", unlimited: true },
  { plan: "비즈니스", a: "30만원", b: "20만원", c: "10만원", unlimited: false },
  { plan: "프로", a: "70만원", b: "45만원", c: "20만원", unlimited: false },
];

export const PROCESS_STEPS = [
  { title: "상담 예약", desc: "사무소 정보와 연락처 등을 알려주시면 담당 매니저가 순차적으로 연락드립니다." },
  { title: "맞춤 플랜 제안", desc: "지역·매물 구성·영업 목표에 맞는 최적의 멤버십 등급과 운영 전략을 제안합니다." },
  { title: "가입 및 운영", desc: "온보딩 후 노출 설정이 완료됩니다. 이후 서비스 내 노출을 확인해보세요!" },
];

export const PLAN_OPTIONS = ["베이직", "비즈니스", "프로", "아직 정하지 못함"];

export const FAQS = [
  {
    q: "소유주(개인)도 매물 광고를 할 수 있나요?",
    a: "디스코는 개업공인중개사 외 소유주(개인)가 광고할 수 있는 상품이 없습니다. 광고를 원하시면 매물 지역에 노출 중인 공인중개사에게 직접 의뢰해 주세요.",
  },
  {
    q: "무료 등급으로도 매물을 등록할 수 있나요?",
    a: "네, 무료 등급도 매물 등록은 무제한입니다. 다만 매물 노출은 유료 등급부터 제공되며, 무료 등급은 서비스 기능을 체험하는 용도로 권장드립니다.",
  },
  {
    q: "유료 등급 가격은 어떻게 되나요?",
    a: "활동 지역 등급(A/B/C)에 따라 월 구독료가 달라집니다. 베이직은 3~9만원, 비즈니스는 10~30만원, 프로는 20~70만원입니다. 정확한 금액은 상담 시 안내드립니다.",
  },
  {
    q: "비즈니스·프로 등급이 ‘지역 정원제’라는 건 어떤 의미인가요?",
    a: "비즈니스와 프로 멤버십은 지역별로 제한된 수의 가입자만 받고 있습니다. 한 지역 내 동일 등급 중개사 수가 상한선에 도달하면 대기 리스트로 안내되며, 베이직 등급은 지역별 가입자 수 제한이 없습니다.",
  },
  {
    q: "가입 후 등급을 변경할 수 있나요?",
    a: "네, 상위·하위 등급으로 변경할 수 있으며 변경은 다음 결제 주기부터 적용됩니다. 비즈니스·프로 등급은 해당 지역 정원에 여유가 있을 때만 업그레이드가 가능하며, 등급 변경은 상담을 통해 진행됩니다.",
  },
  {
    q: "매입 열람권은 무엇인가요?",
    a: "매물을 찾고 있는 매입 희망 고객의 요청 정보를 열람할 수 있는 권한입니다. 비즈니스·프로 등급에 매달 지급되며, 베이직 회원은 기본 지급되지 않습니다.",
  },
  {
    q: "등기 열람권은 어떻게 사용하나요?",
    a: "디스코 실거래가 페이지에서 등기부등본을 무료로 열람할 수 있는 권한입니다. 멤버십 등급에 따라 매달 일정 횟수가 자동 지급되며, 사용하지 않은 잔여 열람권은 다음 달로 이월되지 않습니다.",
    links: [
      { type: "pc-video", url: "https://youtu.be/_dRdkQPmibc?si=97PQ92LYf25nLSDG", label: "PC 사용법 영상" },
      { type: "mobile-video", url: "https://youtube.com/shorts/UgwU2JZGfAo?si=Rs5ntUd0UBxz4zLS", label: "모바일 사용법 영상" },
    ],
  },
  {
    q: "광고 포인트는 어떻게 사용하나요?",
    a: "디스코 PC 홈 화면 우측 하단, 모바일 하단 영역에 노출되는 ‘디스코 추천 광고’에 사용됩니다. 멤버십 등급에 따라 매달 일정 포인트가 자동 지급됩니다.",
    links: [
      { type: "pc-video", url: "https://youtu.be/Zp3LWEfgCM0?si=6JwdXWiKM2c10xtn", label: "PC 사용법 영상" },
      { type: "mobile-video", url: "https://youtube.com/shorts/GhO1aksBfPo?si=eSg_b_x5II3KuYtd", label: "모바일 사용법 영상" },
    ],
  },
  {
    q: "보고서는 어떻게 만드나요?",
    a: "디스코 멤버십 회원은 번거로운 문서 작업 없이 편하게 보고서 생성. 보고서 항목 자유롭게 선택 및 내용 수정 가능",
    links: [
      { type: "doc", url: "https://www.disco.re/b/wdmrszvp/?share", label: "사용법 블로그 보기" },
    ],
  },
  {
    q: "AI 글쓰기 & AI 포스트는 무엇인가요?",
    a: "클릭 몇 번으로 쉽고 빠르게 매물 설명을 작성할 수 있고, 블로그 마케팅을 위한 포스트 자동 생성도 가능합니다.",
    links: [
      { type: "doc", url: "https://www.disco.re/b/9s632v0i/?share", label: "사용법 블로그 보기" },
    ],
  },
];

export const HERO_PHONE_LISTINGS = [
  {
    rank: 1,
    pills: [
      { label: "매매" },
      { label: "프로", variant: "blue" },
    ],
    price: "11억",
    addr: "판교동 532-1 · 토지 327m²",
  },
  {
    rank: 2,
    pills: [
      { label: "전세", variant: "orange" },
      { label: "비즈니스", variant: "blue" },
    ],
    price: "3억 5,000",
    addr: "백현동 541 · 아파트 84m²",
  },
  {
    dim: true,
    pills: [
      { label: "월세", variant: "muted" },
    ],
    price: "500 / 50",
    addr: "운중동 · 원룸",
  },
];
